module.exports = __webpack_public_path__ + "static/media/k.00901148.png";